import type Cookies from 'js-cookie';

export const defaultCookieAttributes: Cookies.CookieAttributes = {
    sameSite: 'strict',
    expires: 15,
    secure: true,
};

export enum CookieKeyEnum {
    FINGERPRINT = 'fingerprint',
    USER_DATA = 'userData',
    DOMAIN = 'domain',
    NEXT_CODE_RESEND_DATE = 'nextCodeResendDate',
    LAST_CONNECTED_EXCHANGE_QUANTITY = 'lastConnectedExchangeQuantity',
    TERMINAL_DATA = 'terminalData',
    APP_DATA = 'appData',
    TRADE_SESSION = 'tradeSession',
    VOLUME_SETTINGS = 'volumeSettings',
    TRADE_STRATEGY_SETTINGS = 'tradeStrategySettingsCookieee',
}
